import React from 'react';
import { InitialProps } from '../../../types';
import { Identification } from '../../components/Identification';

const IdentificationEntry = ({ signingMode, rollouts }: InitialProps) => (
  <Identification mode={signingMode} rollouts={rollouts} />
);

export default IdentificationEntry;
